import { ArrowUpBoldCircleOutlineIcon } from './ArrowUpBoldCircleOutlineIcon';

/**
 * author: Austin Andrews
 * id 3337B267-94EC-426B-ABC9-5842F75B13B1
 * name arrow-up-bold-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopBoldCircleOutlineIcon = ArrowUpBoldCircleOutlineIcon;
export default ArrowTopBoldCircleOutlineIcon